import { store } from "@store";

const getUserLanguage = () => {
  return store.getState()?.auth.user?.user?.language || "en";
};

export default getUserLanguage;
